import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderProvider } from '../providers/order.provider';
import { SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetOrderDocumentsUseCaseParams {
    product: SelectedProductInterface;
}

@Injectable()
export class GetOrderDocumentsUseCase implements UseCaseWithParam<GetOrderDocumentsUseCaseParams, Observable<Transaction<any>>> {
    constructor(private orderProvider: OrderProvider) {}

    bind(params: GetOrderDocumentsUseCaseParams): Observable<Transaction<any>> {
        return this.orderProvider.documents(params.product);
    }
}
